import React, { useContext } from 'react'

import { InAppCommsContext } from 'modules/in_app_comms/store/InAppCommsProvider'

import InAppCommunication from './InAppCommunication'

/**
 * Renders non-banner in-app comms (modal, form, sidebar_card) inside the
 * layout tree so they can access contexts mounted by `<ApplicationFrame>`
 * (e.g. the AI chat provider used by `CommsOpenOneRecord`).
 *
 * Must be rendered inside `InAppCommsProvider` AND inside `<ApplicationFrame>`.
 */
export const InAppCommsContentSlot: React.FC = () => {
  const context = useContext(InAppCommsContext)

  if (!context) return null

  return (
    <>
      {context.activeComms
        .filter((comm) => comm.type !== 'banner')
        .map(({ id, type, content, name }) => (
          <InAppCommunication
            key={id}
            component={{ id, type, content, name }}
            onDismiss={context.dismiss}
          />
        ))}
    </>
  )
}
